// extracted by mini-css-extract-plugin
module.exports = {"mainSpinner":"mainSpinner--1y71E"};